export interface Download {
	url?: string;
	data?: Blob;
	fileName: string;
}

export interface CreateAnchorProps {
	link?: string;
	download?: Download;
	target?: React.HTMLAttributeAnchorTarget;
}

export const createAndClickAnchor = ({
	download,
	link,
	target,
}: CreateAnchorProps) => {
	const href = (download ? download.url : link) as string;
	const downloadName = download && download.fileName;

	const anchor = document.createElement('a');
	anchor.href = href;
	if (downloadName) anchor.download = downloadName;
	anchor.target = target || '_blank';

	anchor.click();
	anchor.remove();
};

export default createAndClickAnchor;
